import { Component, OnInit } from '@angular/core';
import { SfhSecurityService } from '@sasser/sfh-shared-security';
import { SharedModule } from 'app/shared/shared.module';

@Component({
  standalone: true,
  templateUrl: 'secured.component.html',
  selector: 'secured',
  imports: [SharedModule]
})

export class SecuredComponent implements OnInit {
  constructor(private sfhAuth: SfhSecurityService) { }

  ngOnInit() { }

  get userInfo() {
    return this.sfhAuth.userInfo;
  }
}